// NEW Store
import axios from "axios"
import { bus } from "@/main"

const state = {
  baseURL: process.env.VUE_APP_URL,
  route_Images: "/images",

  showPicker: false,

  addnlFUN: false,
  addnlMAC: false,
  addnlNRV: false,
  addnlCOR: false,
  addnlOPA: false,
  addnlPAC: false,
  addnlEXT: false,
  addnlOCT: false,

  expectedImagesFUN: 2,
  expectedImagesMAC: 2,
  expectedImagesNRV: 2,
  expectedImagesCOR: 2,
  expectedImagesOPA: 1,
  expectedImagesPAC: 2,
  expectedImagesEXT: 1,
  expectedImagesOCT: 4,

  imgsObj: {
    arrFUN: [],
    arrMAC: [],
    arrNRV: [],
    arrCOR: [],
    arrOPA: [],
    arrPAC: [],
    arrEXT: [],
    arrOCT: []
  },
  imagesSigned: {
    // fundusPhoto
    fundus: [],
    // maculaPhoto
    macula: [],
    // nervePhoto
    nerve: [],
    // corneaPhoto
    cornea: [],
    // opacityPhoto
    opacity: [],
    // pachymetryPhoto
    pachymetry: [],
    // externalPhoto
    external: [],
    // Optical Coherence Tomography
    opticalCoherence: []
  },
  imgArr: [],
  tmpARR: [],
  latestById: {
    MACOD: null,
    MACOS: null,
    NRVOD: null,
    NRVOS: null
  },
  extractDateFromFile: (fileName) => {
    const match = fileName.match(/_(\d{8})_(\d{6})_/)
    if (!match) return null
    const [_, datePart, timePart] = match
    return new Date(
      `${datePart.substring(0, 4)}-${datePart.substring(4, 6)}-${datePart.substring(6, 8)}T` +
        `${timePart.substring(0, 2)}:${timePart.substring(2, 4)}:${timePart.substring(4, 6)}`
    )
  },
  getTimestamp: (fileName) => {
    const match = fileName.match(/\d{8}_\d{6}/)
    return match ? match[0] : ""
  }
}

const getters = {
  IMGOBJ: (state) => {
    return state.imgsObj
  },
  IMGARR: (state) => {
    return state.imgArr
  },
  addnlFUN: (state) => {
    return state.addnlFUN
  },
  addnlMAC: (state) => {
    if (state.imagesObj.arrFUN.length > 4) {
      return true
    }
    return state.addnlMAC
  },
  addnlNRV: (state) => {
    if (state.imagesObj.arrFUN.length > 4) {
      return true
    }
    return state.addnlNRV
  },
  addnlCOR: (state) => {
    return state.addnlCOR
  },
  addnlOPA: (state) => {
    return state.addnlOPA
  },
  addnlPAC: (state) => {
    return state.addnlPAC
  },
  addnlEXT: (state) => {
    return state.addnlEXT
  },
  addnlOCT: (state) => {
    return state.addnlOCT
  },
  getSignedImages: (state) => {
    return state.imagesSigned
  },
  getAllSignedImagesArray: (state) => {
    // // following the logic for img.arr, we do not get the macula and nerve images
    // const imgsWithoutMacNerve = {
    //   fundus: state.imagesSigned.fundus,
    //   cornea: state.imagesSigned.cornea,
    //   opacity: state.imagesSigned.opacity,
    //   pachymetry: state.imagesSigned.pachymetry,
    //   external: state.imagesSigned.external,
    //   opticalCoherence: state.imagesSigned.opticalCoherence
    // }
    // return Object.values(imgsWithoutMacNerve).flat()
    // showing all images from screening in modal
    const arr = JSON.parse(JSON.stringify(state.tmpARR))
    arr.sort((a,b)=> a.id > b.id ? 1 : -1)
    return arr
  },
  getImageUrlByIds:
    (state) =>
    (category, ids = []) => {
      const images = state.imagesSigned[category]
      if (!images || images.length === 0) return false
      const match = images.find((img) => ids.includes(img.id))
      return match ? match.url : false
    },
  getImageExternal: (state) => {
    if (!state.imagesSigned.external || state.imagesSigned.external.length === 0) {
      return false
    }
    return state.imagesSigned.external.reduce((latest, current) => {
      const getTimestamp = (file) => parseInt(file.match(/_(\d+)\.jpg$/)[1])
      return getTimestamp(current.file) > getTimestamp(latest.file) ? current : latest
    })
  },
  getMaculaImages: (state) => {
    if (!state.imagesSigned.macula || state.imagesSigned.macula.length === 0) {
      return false
    }
    return state.imagesSigned.macula
  },
  getNerveImages: (state) => {
    if (!state.imagesSigned.nerve || state.imagesSigned.nerve.length === 0) {
      return false
    }
    return state.imagesSigned.nerve
  }
}

// Called from Action to change State
const mutations = {
  updtImagePicker: (state, payload) => {
    state.tmpARR.length = 0
    state.imgArr.length = 0
    state.imgsObj.arrFUN.length = 0
    state.imgsObj.arrMAC.length = 0
    state.imgsObj.arrNRV.length = 0
    state.imgsObj.arrCOR.length = 0
    state.imgsObj.arrOPA.length = 0
    state.imgsObj.arrPAC.length = 0
    state.imgsObj.arrEXT.length = 0
    state.imgsObj.arrOCT.length = 0
    state.imagesSigned.fundus.length = 0
    state.imagesSigned.macula.length = 0
    state.imagesSigned.nerve.length = 0
    state.imagesSigned.cornea.length = 0
    state.imagesSigned.opacity.length = 0
    state.imagesSigned.pachymetry.length = 0
    state.imagesSigned.external.length = 0
    state.imagesSigned.opticalCoherence.length = 0

    state.tmpARR = payload
    let maculaAndNerveArray = []
    state.tmpARR.forEach((item) => {
      if (item.file.indexOf(".jpg") !== -1) {
        if (item.id.indexOf("FUN_") !== -1 || item.id.indexOf("FUN") !== -1) {
          state.imgsObj.arrFUN.push("IMAGES/" + item.file) // FUNDUS Images
          state.imagesSigned.fundus.push(item)
        }
        if (item.id == "MACOD" || item.id == "MACOS") {
          state.imgsObj.arrMAC.push("IMAGES/" + item.file) // MACULA Images
          state.imagesSigned.macula.push(item)
        }
        if (item.id == "NRVOD" || item.id == "NRVOS") {
          state.imgsObj.arrNRV.push("IMAGES/" + item.file) // NERVE Images
          state.imagesSigned.nerve.push(item)
        }
        if (item.id.indexOf("COR_") !== -1) {
          state.imgsObj.arrCOR.push("IMAGES/" + item.file) // CORNEA Images
          state.imagesSigned.cornea.push(item)
        }
        if (item.id == "COROD" || item.id == "COROS") {
          state.imgsObj.arrCOR.push("IMAGES/" + item.file) // CORNEA Images
          state.imagesSigned.cornea.push(item)
        }
        if (item.id.indexOf("OPA") !== -1) {
          state.imgsObj.arrOPA.push("IMAGES/" + item.file) // OPACITY Images
          state.imagesSigned.opacity.push(item)
        }
        if (item.id.indexOf("PAC") !== -1) {
          state.imgsObj.arrPAC.push("IMAGES/" + item.file) // PACHYMETRY Images
          state.imagesSigned.pachymetry.push(item)
        }
        if (item.id.indexOf("EXT_") !== -1 || item.id.indexOf("EXT") !== -1) {
          state.imgsObj.arrEXT.push("IMAGES/" + item.file) // EXTERNAL Images
          state.imagesSigned.external.push(item)
        }
        if (item.id.indexOf("SUM_") !== -1) {
          state.imgsObj.arrPAC.push("IMAGES/" + item.file) // EXTERNAL Images
          state.imagesSigned.pachymetry.push(item)
        }
        if (item.id.indexOf("OCT_") !== -1) {
          state.imgsObj.arrOCT.push("IMAGES/" + item.file) // OCT Images
          state.imagesSigned.opticalCoherence.push(item)
        }
        state.imgArr.push("IMAGES/" + item.file) // ALL IMAGE URLS
      }
    })

    ;(state.imgArr = [].concat(
      //state.imgsObj.arrMAC,
      //state.imgsObj.arrNRV,
      state.imgsObj.arrFUN,
      state.imgsObj.arrCOR,
      state.imgsObj.arrPAC,
      state.imgsObj.arrEXT,
      state.imgsObj.arrOPA,
      state.imgsObj.arrOCT
    )),
      /* 
    console.log("imgArr: " + state.imgArr);
    console.log("imgArr: " + state.imgArr.length);
    console.log("arrFUN: " + state.imgsObj.arrFUN.length);
    console.log("arrMAC: " + state.imgsObj.arrMAC.length);
    console.log("arrNRV: " + state.imgsObj.arrNRV.length);
    console.log("arrCOR: " + state.imgsObj.arrCOR.length);
    console.log("arrOPA: " + state.imgsObj.arrOPA.length);
    console.log("arrPAC: " + state.imgsObj.arrPAC.length);
    console.log("arrEXT: " + state.imgsObj.arrEXT.length);
    console.log("arrOCT: " + state.imgsObj.arrOCT.length);
    */

      (state.addnlFUN = state.imgsObj.arrFUN.length > state.expectedImagesFUN)
    state.addnlMAC = state.imgsObj.arrMAC.length > state.expectedImagesMAC
    state.addnlNRV = state.imgsObj.arrNRV.length > state.expectedImagesNRV
    state.addnlCOR = state.imgsObj.arrCOR.length > state.expectedImagesCOR
    state.addnlPAC = state.imgsObj.arrPAC.length > state.expectedImagesPAC
    state.addnlEXT = state.imgsObj.arrEXT.length > state.expectedImagesEXT
    state.addnlOPA = state.imgsObj.arrOPA.length > state.expectedImagesOPA
    state.addnlOCT = state.imgsObj.arrOCT.length > state.expectedImagesOCT

    // SHOW IMAGE BOX //
    if (state.showPicker) {
      bus.$emit("toggleImgBox")
    }
  }
}

// Called externally to commit a State Mutation
const actions = {
  imagePickerList({ commit }, payload) {
    let pkgID = payload.pkgID
    let showPicker = payload.showPicker

    // console.log("showPicker-A: ", showPicker);

    if (showPicker) {
      state.showPicker = showPicker
    } else {
      state.showPicker = false
    }

    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.route_Images + "/" + pkgID
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null
      window.axios.get(url, data, config).then((response) => {
        resolve(response.data)
        commit("updtImagePicker", response.data)
      })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
